"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceType = void 0;
exports.getResourceTypes = getResourceTypes;
exports.getResourceTypeFrom = getResourceTypeFrom;
var ResourceType;
(function (ResourceType) {
    ResourceType["FollowUpAssessment"] = "Follow up Assessment";
    ResourceType["SupportingContent"] = "Supporting Content";
})(ResourceType || (exports.ResourceType = ResourceType = {}));
function getResourceTypes() {
    return Object.values(ResourceType);
}
function getResourceTypeFrom(value) {
    return getResourceTypes().find(function (type) { return type === value; });
}
